import { render } from "./LocationBlock.vue?vue&type=template&id=dfeb9a28&scoped=true"
import script from "./LocationBlock.vue?vue&type=script&lang=js"
export * from "./LocationBlock.vue?vue&type=script&lang=js"

import "./LocationBlock.vue?vue&type=style&index=0&id=dfeb9a28&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfeb9a28"]])

export default __exports__